export const west_virgina = {
  "54000": "West Virginia",
  "54001": "Barbour County",
  "54003": "Berkeley County",
  "54005": "Boone County",
  "54007": "Braxton County",
  "54009": "Brooke County",
  "54011": "Cabell County",
  "54013": "Calhoun County",
  "54015": "Clay County",
  "54017": "Doddridge County",
  "54019": "Fayette County",
  "54021": "Gilmer County",
  "54023": "Grant County",
  "54025": "Greenbrier County",
  "54027": "Hampshire County",
  "54029": "Hancock County",
  "54031": "Hardy County",
  "54033": "Harrison County",
  "54035": "Jackson County",
  "54037": "Jefferson County",
  "54039": "Kanawha County",
  "54041": "Lewis County",
  "54043": "Lincoln County",
  "54045": "Logan County",
  "54047": "McDowell County",
  "54049": "Marion County",
  "54051": "Marshall County",
  "54053": "Mason County",
  "54055": "Mercer County",
  "54057": "Mineral County",
  "54059": "Mingo County",
  "54061": "Monongalia County",
  "54063": "Monroe County",
  "54065": "Morgan County",
  "54067": "Nicholas County",
  "54069": "Ohio County",
  "54071": "Pendleton County",
  "54073": "Pleasants County",
  "54075": "Pocahontas County",
  "54077": "Preston County",
  "54079": "Putnam County",
  "54081": "Raleigh County",
  "54083": "Randolph County",
  "54085": "Ritchie County",
  "54087": "Roane County",
  "54089": "Summers County",
  "54091": "Taylor County",
  "54093": "Tucker County",
  "54095": "Tyler County",
  "54097": "Upshur County",
  "54099": "Wayne County",
  "54101": "Webster County",
  "54103": "Wetzel County",
  "54105": "Wirt County",
  "54107": "Wood County",
  "54109": "Wyoming County",
};
